/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAgents} from '../api'

 export const useQueryGetAgents = createReactQueryHook('getAgents', getAgents)
